import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDeviceSize } from '@surfline/quiver-react';
import { trackEvent } from '@surfline/web-common';
import CreateAccount from '../CreateAccount';
import {
  LEARN_MORE,
  SIGN_IN,
  CLICKED_POPUP,
  FORCED_REGISTRATION,
  NAVIGATED_TO_SIGN_IN,
  NAVIGATED_TO_LEARN_MORE,
} from '../../../../common/constants';

/**
 * @param {SIGN_IN | LEARN_MORE} form
 */
const trackClickedNavigate = (form) =>
  trackEvent(CLICKED_POPUP, {
    action: form === SIGN_IN ? NAVIGATED_TO_SIGN_IN : NAVIGATED_TO_LEARN_MORE,
    category: FORCED_REGISTRATION,
  });

const Home = ({ setForm }) => {
  const { isMobile } = useDeviceSize();
  const headerText = 'Keep Checking the Surf with a Free Account';
  const subHeaderText = isMobile
    ? 'Registered users get more access.'
    : 'Registered users get more access to ad-free cams and long-range forecasts.';

  const handleNavigation = useCallback(
    (formName) => {
      trackClickedNavigate(formName);
      setForm(formName);
    },
    [setForm],
  );

  return (
    <div style={{ width: '100%' }} data-scroll-lock-scrollable="true">
      <div className="sl-meter-bottom-sheet-home__container">
        <h1 className="sl-meter-bottom-sheet-home__header">{headerText}</h1>
        <div className="sl-meter-bottom-sheet-home__subheader">
          <h4>{subHeaderText}</h4>
          <button
            style={{ paddingLeft: '4px' }}
            type="button"
            onClick={() => handleNavigation(LEARN_MORE)}
          >
            Learn More
          </button>
        </div>
        <CreateAccount />
        <div className="sl-meter-bottom-sheet-home__actions">
          <div className="sl-meter-bottom-sheet-home__signin__label">
            Already have an account?
            <button
              type="button"
              onClick={() => handleNavigation(SIGN_IN)}
              className="sl-meter-bottom-sheet-home__signin__button"
            >
              Sign In.
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

Home.propTypes = {
  setForm: PropTypes.func.isRequired,
};

export default Home;
